import { fetchValue, updateValue } from '../../library/siteCookie'

const CONTINENT_API_URL = '/api/regionByContinent?continent'
const REGION_API_URL = '/api/repByRegion2.json?region'
const COOKIE_NAME = 'rep_info_2'

export default ($el) =>
  ({
    el: $el,
    region: {
      title: '',
      slug: '',
    },
    continent: {
      title: 'United States',
      slug: '',
      regions: [],
    },
    rep: {
      name: '',
      fullName: '',
      jobTitle: '',
      email: '',
      emailLink: '',
      image: '',
      id: '',
    },

    store: {
      json: '',
      object: {},
    },

    // state management
    finderReady: true,
    selectorOpen: true,
    hasRegionSelection: false,
    regionOptsFiltered: true,
    isLoading: false,
    isLoadingRegions: false,
    hasImage: true,

    // functions
    init() {
      this.initLoad()
    },

    fetchContinent(slug) {
      this.isLoadingRegions = true
      const url = `${CONTINENT_API_URL}=${slug}`
      const updateSelectedContent = {
        title: slug,
        slug,
      }
      console.info('request: ', url)
      fetch(url)
        .then((res) =>
          res.json())
        .then((data) => {
          updateSelectedContent.regions = data
          this.continent = updateSelectedContent

          // if we have more than 1 option
          // load up the regions otherwise
          // find the default rep for that
          // continent
          if (data.length >= 2) {
            this.hasRegionSelection = true
          } else {
            this.handleContinentDefault()
          }
        })
    },

    handleContinentDefault() {
      const defaultRegion = this.continent.regions[0]
      this.fetchRegion(defaultRegion.value, this.continent.title, true)
      this.hasRegionSelection = false
    },

    fetchRegion(slug, title = null, isDefault = false) {
      const fetchTitle = title || slug
      const url = `${REGION_API_URL}=${slug}&title=${fetchTitle}&default=${isDefault}`

      console.log(url)
      fetch(url)
        .then((res) =>
          res.json())
        .then((data) => {
          // get first record
          const matched = data[0]
          this.rep = matched
          this.region.title = fetchTitle
          this.region.slug = matched.region

          // prep info for cookie storage
          this.store.object = {
            slug,
            title,
            isDefault,
            continent: this.continent.title,
          }
          this.updateStoredData()

          // hide selection
          this.handleHideSelector()
        })
    },

    // watch select inputs
    handleContinentSelection($event) {
      const { currentTarget } = $event
      const { value } = currentTarget
      this.fetchContinent(value)
    },

    handleRegionSelection($event) {
      const { currentTarget } = $event
      const { value } = currentTarget
      const selectedText = currentTarget.options[currentTarget.selectedIndex].text ?? ''
      this.fetchRegion(value, selectedText)
    },

    handleShowSelector() {
      this.selectorOpen = true
    },
    handleHideSelector() {
      this.selectorOpen = false
    },

    // store and retrieve user selections
    updateStoredData() {
      this.store.json = JSON.stringify(this.store.object)
      updateValue(COOKIE_NAME, this.store.json)
    },

    initLoad() {
      this.store.json = fetchValue(COOKIE_NAME)
      this.store.object = JSON.parse(this.store.json)
      // prefer the cookie over IP find
      let region = {}
      if (this.store.object && 'slug' in this.store.object) {
        region = this.store.object
      } else {
        region.slug = this.el.dataset.region
        region.title = this.el.dataset.region
      }
      this.fetchRegion(region.slug, region.title, region.isDefault ?? 'true')
    },
  })
